module.exports = __webpack_public_path__ + "static/media/office-building-P6EY7D6-min.0c58e4b2.jpg";